import { render, staticRenderFns } from "./BoPageTitle.vue?vue&type=template&id=2c8af3a2&"
import script from "./BoPageTitle.vue?vue&type=script&lang=js&"
export * from "./BoPageTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports